// extracted by mini-css-extract-plugin
export default {"footerButtons":"TeYIqz","footerButtonsColumn":"vTxCdo"};